export default "__VITE_ASSET__5344b67d__"